import { createFiltersReducer } from '../utils';
import { ACTIONS_PREFIX } from '../actions/virtualMachinesFilters';

const initialFiltersState = {
    pageNumber: 1,
    sortBy: 'name',
    sortOrder: 'asc',
    strict: false,
    virtualMachines: [],
    virtualMachineIds: [],
    isAppliedFilter: false
};

const initialState = {
    currentFilters: {
        ...initialFiltersState
    },
    appliedFilters: {
        ...initialFiltersState
    }
};

const VMFiltersReducer = createFiltersReducer(ACTIONS_PREFIX, initialState);
export default VMFiltersReducer;
